import { Button, Upload } from 'antd';
import { InboxOutlined } from '@ant-design/icons';

const { Dragger } = Upload;

const TwoStepsUpload = ({onUpload, onRemove, fileList, setFileList, beforeUpload = null, style, ...props}) => {
	function isImageUrl ({url}) {
		if(!url) return false;
		return url.endsWith('png') || url.endsWith('jpg');
	}

	function handleBeforeUpload (file) {
		const check = beforeUpload?.(file) ?? true;
		if (!check) {
			return false;
		}

		setFileList([file]);

		return true;
	}

	async function handleUpload () {
		await onUpload(fileList);
	}

	return (
		<div style={style}>
			<Dragger
				listType="picture"
				fileList={fileList}
				className='bulk-upload__row'
				multiple={false}
				beforeUpload={handleBeforeUpload}
				onRemove={onRemove}
				isImageUrl={isImageUrl}
				{...props}
			>
				<p className="ant-upload-drag-icon">
					<InboxOutlined />
				</p>
				<p className="ant-upload-text">Click or drag file to this area to upload</p>
			</Dragger>
			<Button
				type="primary"
				onClick={handleUpload}
				disabled={fileList.length === 0}
				style={{ marginTop: 16 }}
			>
				Confirm upload
			</Button>
		</div>
	);
};

export default TwoStepsUpload;